import {
	CLEAR_RESULTS,
	SET_SEARCH_INPUT_VALUE,
	RESET_SEARCH,
	SET_ACTIVE_TAB,
	SET_PAGE,
	SET_SELECTED_FILTERS,
	INCREMENT_PAGE,
	TOGGLE_FILTER,
	REMOVE_FILTER,
	SET_SHOULD_SEARCH,
	FETCH_RESULTS_LOADING,
	FETCH_RESULTS_SUCCESS,
	FETCH_RESULTS_ERROR,
} from './actions';

export const initialState = {
	activeTab: '',
	description: '',
	filters: {
		locations: {
			post_title: 'Locations',
			data: [],
		},
		projectTypes: {
			post_title: 'Project Types',
			data: [],
		},
		services: {
			post_title: 'Services',
			data: [],
		},
		contentTypes: {
			post_title: 'Content Types',
			data: [],
		}
	},
	hasNextPage: null,
	incrementPageRequest: false,
	page: 0,
	resultsPerPage: 18,
	searchInputValue: '',
	selectedFilters: [],
	lastSuccessfulSearch: {
		hasNextPage: null,
		incrementPageRequest: false,
		page: 0,
		searchInputValue: '',
		selectedFilters: [],
		searchIsEmpty: true,
	},
	results: [],
	featuredResults: [],
	featuredTitle: null,
	loading: false,
	shouldSearch: false,
	error: null,
	totalMatches: null,
};

export default function reducer( state, action = {} ) {
	
	switch ( action.type ) {
			case CLEAR_RESULTS: {
				return {
					...state,
					results: [],
					page: 0,
				};
			}

			case FETCH_RESULTS_LOADING: {
				return {
					...state,
					loading: true,
					error: false,
				};
			}

			case FETCH_RESULTS_SUCCESS: {
				return {
					...state,
					...action,
					loading: false,
					incrementPageRequest: false,
					error: false,
				};
			}

			case FETCH_RESULTS_ERROR: {
				console.error( action.error );
				return {
					...state,
					loading: false,
					error: action.error,
					incrementPageRequest: false,
				};
			}

			case INCREMENT_PAGE: {
				return {
					...state,
					incrementPageRequest: true,
				};
			}

			case REMOVE_FILTER: {
				const { selectedFilters } = state;
				const newSelectedFilters = [...selectedFilters];

				newSelectedFilters[action.groupIndex] = selectedFilters[
					action.groupIndex
				].filter( name => name !== action.filterName );

				return {
					...state,
					selectedFilters: newSelectedFilters,
					incrementPageRequest: false,
				};
			}

			case RESET_SEARCH: {
				return {
					...initialState,
					filters: state.filters,
					description: state.description,
					selectedFilters: state.selectedFilters.map( () => [] ),
				};
			}

			case SET_ACTIVE_TAB: {
				return {
					...state,
					activeTab: action.activeTab,
				};
			}

			case SET_PAGE: {
				return {
					...state,
					page: action.page,
				};
			}

			case SET_SEARCH_INPUT_VALUE: {
				return {
					...state,
					searchInputValue: action.searchInputValue,
					incrementPageRequest: false,
				};
			}

			case SET_SELECTED_FILTERS: {
				return {
					...state,
					selectedFilters: action.selectedFilters,
					incrementPageRequest: false,
				};
			}

			case SET_SHOULD_SEARCH: {
				return {
					...state,
					shouldSearch: action.shouldSearch,
				};
			}

			case TOGGLE_FILTER: {
				const { selectedFilters } = state;
				const { groupIndex, filterName } = action;

				const newSelectedfilters = [...selectedFilters];
				const filterSet = selectedFilters[groupIndex];

				let nextFilterSet = [];
				if ( filterSet.includes( filterName ) ) {
					nextFilterSet = filterSet.filter( name => name !== filterName );
				} else {
					nextFilterSet = [...filterSet, filterName];
				}

				newSelectedfilters[groupIndex] = nextFilterSet;
				return {
					...state,
					selectedFilters: newSelectedfilters,
				};
			}

			default: {
				return state;
			}
	}
	
}
